export default "__VITE_ASSET__4E2r0ltJ__"